<div class="relative flex flex-col flex-auto min-w-0 overflow-hidden">
    <!-- Header & Cards -->
    <div class="relative pt-8 pb-12 sm:pt-20 sm:pb-24 px-6 sm:px-16 overflow-hidden">
        <!-- Background - @formatter:off -->
        <svg class="-z-1 absolute inset-0" viewBox="0 0 960 540" width="100%" height="100%"
            preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
            <g class="opacity-40 text-gray-200 dark:text-gray-800" fill="none" stroke="currentColor" stroke-width="100">
                <circle r="234" cx="196" cy="23"></circle>
                <circle r="234" cx="790" cy="491"></circle>
            </g>
        </svg>
        <!-- @formatter:on -->
        <!-- Header -->
        <div class="flex flex-col items-center">
            <h2 class="text-xl font-semibold">Bienvenido de nuevo, es hora de configurar una nueva empresa.</h2>
            <div class="mt-1 text-4xl sm:text-7xl font-extrabold tracking-tight leading-tight text-center">
                Configuración de nueva empresa
            </div>
            <div class="mt-3 sm:text-2xl text-center tracking-tight text-secondary">
                <div class="">Sigue estos pasos sencillos para configurar tu nueva empresa de manera <br>eficaz y rápida. ¡Estamos aquí para asistirte en cada etapa del proceso!</div>
            </div>
        </div>

        <br><br><br>
        <app-wizzard-company></app-wizzard-company>
    </div>
</div>
